import { render } from "./quick-add-success.vue?vue&type=template&id=1fe1fc20"
import script from "./quick-add-success.vue?vue&type=script&lang=js"
export * from "./quick-add-success.vue?vue&type=script&lang=js"

import "./quick-add-success.vue?vue&type=style&index=0&id=1fe1fc20&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__